import { usePostHog } from 'posthog-js/react';

/**
 * Custom hook to track PostHog events in React components.
 * Usage: const track = usePosthogEvent(); track('event_name', { prop: value })
 */
export function usePosthogEvent() {
  const posthog = usePostHog();
  return function track(event: string, properties?: Record<string, any>) {
    if (posthog) {
      posthog.capture(event, properties);
    }
  };
}
